import React, { useEffect, useState, useRef } from 'react';
import InputSelect from '../../../select/InputSelect';
import InputLogin from '../../../inputs/InputLogin';
import SelectDocument from '../../../select/selectDocument';
import SelectPhone from '../../../select/selectPhone'
import { motion } from 'framer-motion';
import { FormatMontoPSE, formatPhoneNumber, handlePhoneInputChange, handleEmailChange } from '../../../../utils/Utils'
import ModalAlert from '../../../modal/ModalAlert';
import LoadingSpinner from '../../../spinners/LoadingSpinner';
import { ReactComponent as Check } from '../../../../assets/IconsColurs/IconsGeneral/checkFilled.svg'
import { formatCurrency } from '../../../../utils/FormatCurrency'

import InputAmount from '../../../inputs/InputAmount'
import InputSelectMethod from '../../../inputs/inputSelectMethod'
import ButtonSelect from '../../../button/ButtonSelect'

import Bank from '../../../../assets/IconsColurs/IconsGeneral/bank.png'
import Venmo from '../../../../assets/IconsColurs/IconsGeneral/venmo.png'
import Paypal from '../../../../assets/IconsColurs/IconsGeneral/paypal.png'

import COP from '../../../../assets/currency/copu.png'
import USD from '../../../../assets/currency/usd.png'

const FastSend = ({
    bank,
    checkbooksList,
    setSelectMethod,
    selectMethod,
    quote,
    currencyCoin,
    setActiveButton,
    TotalReceibe,
    BankUserList,
    activeButton,
    TotalPaid,
    setBank,
    GMF,
    FeeAmount,
    FeeIvaAmount,
    isVisible,
    montoPSE,
    currency,
    balanceWalletCop,
    balanceWalletUsd,
    setCorreo,
    correo,
    handleAccountCreate,
    setDocument,
    listDocument,
    numDocument,
    setNumDocument,
    setCountry,
    listCountry,
    phone,
    setPhone,
    modalVariants,
    montoCompra,
    ivaCompra,
    totalCompra,
    montoPSError,
    correoError,
    phoneError,
    numDocumentError,
    setMontoPSE,
    setCorreoError,
    setCorreoValid,
    BankList,
    FinishTransfertPSE,
    alertFinistTransfert,
    errorMessagePSE,
    banckErroPSE,
    loadingResumenPSE,
    comisionCompra,
    setCurrency

}) => {

    const aQuienEnviasRef = useRef(null);

    useEffect(() => {
        if (selectMethod && aQuienEnviasRef.current) {
            aQuienEnviasRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }, [selectMethod]);

    useEffect(() => {
        setBank(null);
    }, [selectMethod]);

    const getBankList = () => {
        if (currency === 'USD' && checkbooksList) {
            let list = [];
            switch (selectMethod) {
                case 'banco':
                    list = checkbooksList.ACH || [];
                    break;
                case 'paypal':
                    list = checkbooksList.PAYPAL || [];
                    break;
                case 'venmo':
                    list = checkbooksList.VENMO || [];
                    break;
                default:
                    list = [];
            }
            return list.map(item => ({
                ...item,
                bank_name: selectMethod === 'banco' ? 'Cuenta de banco' : selectMethod.charAt(0).toUpperCase() + selectMethod.slice(1),
                account_number: item.routing || item.username,
                account_holder_name: item.name,
                account_type: item.type
            }));
        }
        if (currency === 'COP') {
            return BankUserList;
        }
        return [];
    };

    return (
        <>
            <div className="w-full h-full mt-5 flex flex-col gap-3">


                {!quote && <div className='flex justify-center'>
                    <ButtonSelect activeButton={activeButton} setActiveButton={setActiveButton} />
                </div>}
                {alertFinistTransfert && <ModalAlert title='Transferencia exitosa' description='En pocos minutos tus COP se verán reflejados en tu billetera' className={`text-start`} labelButtonWhite='Perfecto' icon={Check} onClick={FinishTransfertPSE} />}
                <InputAmount select={quote === true ? false : true} currency={currency} setCurrency={setCurrency} value={montoPSE} onChange={(e) => setMontoPSE(e)} error={montoPSError} errorMessage={montoPSError} title={"Envías"} />
                <div className='w-full h-auto flex flex-col gap-3 mt-2'>
                    <div className='w-full h-auto flex flex-col sm:flex-row justify-between bg-[#2B2B33] px-3 sm:px-4 py-2 sm:py-3 rounded-lg'>
                        <p className='text-sm sm:text-base font-medium traking-[-0.32px] leading-5 text-[#8A8A8E]'>
                            Saldo disponible:
                        </p>
                        <div className='w-full sm:w-[65%] flex justify-end mt-1 sm:mt-0'>
                            <p className='text-right'>{currency === "COP" ? formatCurrency(balanceWalletCop) : formatCurrency(balanceWalletUsd)} {currency}</p>
                        </div>
                    </div>
                </div>
                {currency === 'USD' && activeButton !== "usuario" && <div className='flex flex-col gap-3 mb-4'>
                    <p className='text-sm font-medium text-[#8A8A8E]'>ELIGE TU MEDIO DE PAGO</p>
                    <div className='grid grid-cols-3 gap-3'>
                        <div
                            onClick={() => setSelectMethod('banco')}
                            className={`cursor-pointer p-4 flex flex-col justify-start items-start gap-2 flex-1 rounded-xl bg-[#2B2B33] backdrop-blur-[50px] min-h-[90px] border ${selectMethod === 'banco' ? 'border-white' : 'border-transparent'}`}>
                            {/* Logo placeholder - user will add it */}
                            <img src={Bank} alt="Bank" className='w-8 h-8 bg-[#2B2B33] rounded-lg' />
                            <p className='text-white font-medium'>Banco</p>
                        </div>
                        <div
                            onClick={() => setSelectMethod('venmo')}
                            className={`cursor-pointer p-4 flex flex-col justify-start items-start gap-2 flex-1 rounded-xl bg-[#2B2B33] backdrop-blur-[50px] min-h-[90px] border ${selectMethod === 'venmo' ? 'border-white' : 'border-transparent'}`}>
                            {/* Logo placeholder */}
                            <img src={Venmo} alt="Venmo" className='w-8 h-8 bg-blue-500 rounded-lg' />
                            <p className='text-white font-medium'>Venmo</p>
                        </div>
                        <div
                            onClick={() => setSelectMethod('paypal')}
                            className={`cursor-pointer p-4 flex flex-col justify-start items-start gap-2 flex-1 rounded-xl bg-[#2B2B33] backdrop-blur-[50px] min-h-[90px] border ${selectMethod === 'paypal' ? 'border-white' : 'border-transparent'}`}>
                            {/* Logo placeholder */}
                            <img src={Paypal} alt="Paypal" className='w-8 h-8 bg-blue-200 rounded-lg' />
                            <p className='text-white font-medium'>PayPal</p>
                        </div>
                    </div>
                </div>}
                {activeButton !== "usuario" && ((currency === 'USD' && selectMethod) || currency === 'COP') && <div ref={aQuienEnviasRef} className='w-full h-auto flex flex-col gap-2 sm:gap-3'>
                    <div className='w-full h-auto flex flex-col justify-between'>
                        <p className='text-sm sm:text-base font-medium traking-[-0.32px] leading-5 text-left pb-2 mt-3 sm:mt-4'>
                            A quien envías
                        </p>
                        <div className={`w-[100%] flex flex-row gap-1 ${isVisible ? 'pb-0' : 'pb-10'} overflow-visible`}>
                            <InputSelectMethod
                                bank={bank}
                                handleAccountCreate={handleAccountCreate}
                                data={getBankList()}
                                setBank={setBank}
                                selectMethod={selectMethod}
                                currency={currency}
                            />
                        </div>
                    </div>
                </div>}
                {activeButton === "usuario" && <div className='w-full h-auto flex flex-col gap-2 sm:gap-3'>
                    <div className='w-full h-auto flex flex-col justify-between'>
                        <p className='text-sm sm:text-base font-medium traking-[-0.32px] leading-5 text-left pb-2 mt-3 sm:mt-4'>
                            A quien envías
                        </p>
                        <div className='w-[100%] flex flex-row gap-1'>
                            <InputLogin
                                placeholder="Celular, correo o nombre de usuario"
                                value={correo}
                                onChange={(e) => setCorreo(e)}
                                error={correoError}
                            />
                        </div>
                    </div>
                </div>}

                <div className='w-full h-auto flex flex-col gap-2 sm:gap-3'>
                    <div className='w-full h-auto flex flex-row justify-between'>
                        <div className='w-full flex flex-row gap-1'>
                            <p className='text-[13px] sm:text-[14px] text-center text-[#e4847f]'>{errorMessagePSE}</p>
                        </div>
                    </div>
                </div>

                {loadingResumenPSE && <LoadingSpinner />}

                {isVisible && !loadingResumenPSE && (
                    <motion.div
                        className="bg-[#26262D]"
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <div
                            className={`transition-all duration-900 ease-in-out ${isVisible ? 'opacity-100 translateY-0' : 'opacity-0 translateY-5'}`}
                        >
                            <p className="text-sm sm:text-base text-[#8A8A8E] flex font-semibold tracking-tight leading-5 mb-2">Resumen</p>
                            <div className='w-full h-auto bg-[#2B2B33] rounded-lg p-3 sm:p-5'>
                                <div className='w-full justify-between flex flex-row py-2'>
                                    <p className='text-[13px] sm:text-[14px] font-normal tracking-[-0.14px] leading-[18.2px] text-[#8A8A8E]'>Monto a enviar</p>
                                    <p className='text-[14px] sm:text-[16px] font-bold tracking-[-0.14px] leading-[18.2px] text-[#ffffff]'>{FormatMontoPSE(montoPSE, true, currency === "USD" ? "." : ",")}</p>
                                </div>
                                <div className='w-full justify-between flex flex-row py-2'>
                                    <p className='text-[13px] sm:text-[14px] font-normal tracking-[-0.14px] leading-[18.2px] text-[#8A8A8E]'>Comisión envío</p>
                                    <p className='text-[14px] sm:text-[16px] font-bold tracking-[-0.14px] leading-[18.2px] text-[#ffffff]'>{FormatMontoPSE(FeeAmount, true, currency === "USD" ? "." : ",")}</p>
                                </div>
                                {FeeIvaAmount !== 0 && <div className='w-full justify-between flex flex-row py-2'>
                                    <p className='text-[13px] sm:text-[14px] font-normal tracking-[-0.14px] leading-[18.2px] text-[#8A8A8E]'>IVA comisión envío</p>
                                    <p className='text-[14px] sm:text-[16px] font-bold tracking-[-0.14px] leading-[18.2px] text-[#ffffff]'>{FormatMontoPSE(FeeIvaAmount, true, currency === "USD" ? "." : ",")}</p>
                                </div>}
                                {activeButton !== "usuario" && GMF !== 0 && <div className='w-full justify-between flex flex-row py-2'>
                                    <p className='text-[13px] sm:text-[14px] font-normal tracking-[-0.14px] leading-[18.2px] text-[#8A8A8E]'>GMF</p>
                                    <p className='text-[14px] sm:text-[16px] font-bold tracking-[-0.14px] leading-[18.2px] text-[#ffffff]'>{FormatMontoPSE(GMF, true, currency === "USD" ? "." : ",")}</p>
                                </div>}
                                <div className="w-full border-t border-dashed border-[#8A8A8E] my-2"></div>
                                <div className='w-full justify-between flex flex-row py-2'>
                                    <p className='text-[13px] sm:text-[14px] font-normal tracking-[-0.14px] leading-[18.2px] text-[#8A8A8E]'>Total a Recibir</p>
                                    <p className='text-[14px] sm:text-[16px] font-bold tracking-[-0.14px] leading-[18.2px] text-[#ffffff]'>{FormatMontoPSE(TotalReceibe, true, currency === "USD" ? "." : ",")}</p>
                                </div>
                            </div>
                        </div>
                    </motion.div>)}
            </div>
        </>
    );
};

export default FastSend;
